module.exports = {
	"ha": "vcha",
	"id": 5.5,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2022 Q1–2023 Q4",
		"lastYear": "2023",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by Age Category and MSM Status, Year Ending 2023 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 93.97590361445783,
						"dataLabels": {
							"enabled": false,
							"format": "78"
						},
						"color": "#043f61"
					},
					{
						"y": 90.36144578313254,
						"dataLabels": {
							"enabled": false,
							"format": "75"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.74698795180723,
						"dataLabels": {
							"enabled": false,
							"format": "72"
						},
						"color": "#0d4440"
					},
					{
						"y": 78.3132530120482,
						"dataLabels": {
							"enabled": false,
							"format": "65"
						},
						"color": "#09472e"
					},
					{
						"y": 68.67469879518072,
						"dataLabels": {
							"enabled": false,
							"format": "57"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.9685534591195,
						"dataLabels": {
							"enabled": false,
							"format": "302"
						},
						"color": "#043f61"
					},
					{
						"y": 85.53459119496856,
						"dataLabels": {
							"enabled": false,
							"format": "272"
						},
						"color": "#0c4250"
					},
					{
						"y": 82.38993710691824,
						"dataLabels": {
							"enabled": false,
							"format": "262"
						},
						"color": "#0d4440"
					},
					{
						"y": 73.27044025157232,
						"dataLabels": {
							"enabled": false,
							"format": "233"
						},
						"color": "#09472e"
					},
					{
						"y": 65.72327044025157,
						"dataLabels": {
							"enabled": false,
							"format": "209"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.35449735449735,
						"dataLabels": {
							"enabled": false,
							"format": "368"
						},
						"color": "#043f61"
					},
					{
						"y": 86.5079365079365,
						"dataLabels": {
							"enabled": false,
							"format": "327"
						},
						"color": "#0c4250"
					},
					{
						"y": 84.39153439153439,
						"dataLabels": {
							"enabled": false,
							"format": "319"
						},
						"color": "#0d4440"
					},
					{
						"y": 78.04232804232805,
						"dataLabels": {
							"enabled": false,
							"format": "295"
						},
						"color": "#09472e"
					},
					{
						"y": 67.46031746031747,
						"dataLabels": {
							"enabled": false,
							"format": "255"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.85994397759103,
						"dataLabels": {
							"enabled": false,
							"format": "1426"
						},
						"color": "#043f61"
					},
					{
						"y": 93.62745098039215,
						"dataLabels": {
							"enabled": false,
							"format": "1337"
						},
						"color": "#0c4250"
					},
					{
						"y": 91.45658263305322,
						"dataLabels": {
							"enabled": false,
							"format": "1306"
						},
						"color": "#0d4440"
					},
					{
						"y": 87.6750700280112,
						"dataLabels": {
							"enabled": false,
							"format": "1252"
						},
						"color": "#09472e"
					},
					{
						"y": 77.94117647058823,
						"dataLabels": {
							"enabled": false,
							"format": "1113"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 94.11764705882352,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#043f61"
					},
					{
						"y": 88.23529411764706,
						"dataLabels": {
							"enabled": false,
							"format": "15"
						},
						"color": "#0c4250"
					},
					{
						"y": 88.23529411764706,
						"dataLabels": {
							"enabled": false,
							"format": "15"
						},
						"color": "#0d4440"
					},
					{
						"y": 64.70588235294117,
						"dataLabels": {
							"enabled": false,
							"format": "11"
						},
						"color": "#09472e"
					},
					{
						"y": 35.294117647058826,
						"dataLabels": {
							"enabled": false,
							"format": "6"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.05825242718447,
						"dataLabels": {
							"enabled": false,
							"format": "101"
						},
						"color": "#043f61"
					},
					{
						"y": 93.20388349514563,
						"dataLabels": {
							"enabled": false,
							"format": "96"
						},
						"color": "#0c4250"
					},
					{
						"y": 89.32038834951457,
						"dataLabels": {
							"enabled": false,
							"format": "92"
						},
						"color": "#0d4440"
					},
					{
						"y": 76.69902912621359,
						"dataLabels": {
							"enabled": false,
							"format": "79"
						},
						"color": "#09472e"
					},
					{
						"y": 46.601941747572816,
						"dataLabels": {
							"enabled": false,
							"format": "48"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.52153110047847,
						"dataLabels": {
							"enabled": false,
							"format": "208"
						},
						"color": "#043f61"
					},
					{
						"y": 96.17224880382776,
						"dataLabels": {
							"enabled": false,
							"format": "201"
						},
						"color": "#0c4250"
					},
					{
						"y": 92.82296650717703,
						"dataLabels": {
							"enabled": false,
							"format": "194"
						},
						"color": "#0d4440"
					},
					{
						"y": 80.38277511961722,
						"dataLabels": {
							"enabled": false,
							"format": "168"
						},
						"color": "#09472e"
					},
					{
						"y": 55.02392344497608,
						"dataLabels": {
							"enabled": false,
							"format": "115"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.12790697674419,
						"dataLabels": {
							"enabled": false,
							"format": "682"
						},
						"color": "#043f61"
					},
					{
						"y": 98.83720930232558,
						"dataLabels": {
							"enabled": false,
							"format": "680"
						},
						"color": "#0c4250"
					},
					{
						"y": 95.05813953488372,
						"dataLabels": {
							"enabled": false,
							"format": "654"
						},
						"color": "#0d4440"
					},
					{
						"y": 89.24418604651163,
						"dataLabels": {
							"enabled": false,
							"format": "614"
						},
						"color": "#09472e"
					},
					{
						"y": 69.3313953488372,
						"dataLabels": {
							"enabled": false,
							"format": "477"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 40.25974025974026,
						"dataLabels": {
							"enabled": false,
							"format": "31"
						},
						"color": "#043f61"
					},
					{
						"y": 35.064935064935064,
						"dataLabels": {
							"enabled": false,
							"format": "27"
						},
						"color": "#0c4250"
					},
					{
						"y": 35.064935064935064,
						"dataLabels": {
							"enabled": false,
							"format": "27"
						},
						"color": "#0d4440"
					},
					{
						"y": 33.76623376623377,
						"dataLabels": {
							"enabled": false,
							"format": "26"
						},
						"color": "#09472e"
					},
					{
						"y": 27.27272727272727,
						"dataLabels": {
							"enabled": false,
							"format": "21"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 92.61744966442953,
						"dataLabels": {
							"enabled": false,
							"format": "138"
						},
						"color": "#043f61"
					},
					{
						"y": 81.87919463087249,
						"dataLabels": {
							"enabled": false,
							"format": "122"
						},
						"color": "#0c4250"
					},
					{
						"y": 79.86577181208054,
						"dataLabels": {
							"enabled": false,
							"format": "119"
						},
						"color": "#0d4440"
					},
					{
						"y": 70.46979865771812,
						"dataLabels": {
							"enabled": false,
							"format": "105"
						},
						"color": "#09472e"
					},
					{
						"y": 55.70469798657718,
						"dataLabels": {
							"enabled": false,
							"format": "83"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 95.52845528455285,
						"dataLabels": {
							"enabled": false,
							"format": "235"
						},
						"color": "#043f61"
					},
					{
						"y": 79.67479674796748,
						"dataLabels": {
							"enabled": false,
							"format": "196"
						},
						"color": "#0c4250"
					},
					{
						"y": 77.64227642276423,
						"dataLabels": {
							"enabled": false,
							"format": "191"
						},
						"color": "#0d4440"
					},
					{
						"y": 72.35772357723577,
						"dataLabels": {
							"enabled": false,
							"format": "178"
						},
						"color": "#09472e"
					},
					{
						"y": 59.756097560975604,
						"dataLabels": {
							"enabled": false,
							"format": "147"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.01406799531067,
						"dataLabels": {
							"enabled": false,
							"format": "819"
						},
						"color": "#043f61"
					},
					{
						"y": 72.80187573270808,
						"dataLabels": {
							"enabled": false,
							"format": "621"
						},
						"color": "#0c4250"
					},
					{
						"y": 70.69167643610785,
						"dataLabels": {
							"enabled": false,
							"format": "603"
						},
						"color": "#0d4440"
					},
					{
						"y": 68.81594372801875,
						"dataLabels": {
							"enabled": false,
							"format": "587"
						},
						"color": "#09472e"
					},
					{
						"y": 59.55451348182884,
						"dataLabels": {
							"enabled": false,
							"format": "508"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -6.024096385542165,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.8461538461538436,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.0000000000000036,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.722222222222221,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.307692307692308,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.031446540880502,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.93377483443708,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.676470588235292,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.068702290076338,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.300429184549353,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.645502645502651,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.141304347826086,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.4464831804281384,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.523510971786829,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.559322033898303,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.1400560224089631,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.241234221598879,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.3186237845923663,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.134762633996935,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.102236421725243,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -5.882352941176472,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.25,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -26.66666666666667,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -45.45454545454546,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.9417475728155331,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.950495049504955,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.1666666666666625,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.130434782608692,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -39.24050632911392,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.4784688995215336,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.3653846153846145,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.482587064676612,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.4020618556701,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -31.547619047619047,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.8720930232558155,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -0.2932551319648091,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.8235294117647034,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.11620795107034,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -22.31270358306189,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -59.74025974025974,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -12.903225806451612,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.703703703703709,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.23076923076923,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -7.38255033557047,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.594202898550721,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.4590163934426257,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.764705882352944,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.952380952380956,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -4.471544715447151,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -16.595744680851066,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.5510204081632626,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.806282722513091,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.41573033707865,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.98593200468933,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.17582417582418,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.898550724637683,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.6533996683250405,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.458262350936966,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=83"
			},
			{
				"x": 9,
				"text": "30-39<br>n=318"
			},
			{
				"x": 15,
				"text": "40-49<br>n=378"
			},
			{
				"x": 21,
				"text": ">=50<br>n=1428"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=17"
			},
			{
				"x": 34,
				"text": "30-39<br>n=103"
			},
			{
				"x": 40,
				"text": "40-49<br>n=209"
			},
			{
				"x": 46,
				"text": ">=50<br>n=688"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=77"
			},
			{
				"x": 59,
				"text": "30-39<br>n=149"
			},
			{
				"x": 65,
				"text": "40-49<br>n=246"
			},
			{
				"x": 71,
				"text": ">=50<br>n=853"
			}
		],
		"dataTable": {
			"MSM:<30": [
				83,
				78,
				75,
				72,
				65,
				57
			],
			"MSM:30-39": [
				318,
				302,
				272,
				262,
				233,
				209
			],
			"MSM:40-49": [
				378,
				368,
				327,
				319,
				295,
				255
			],
			"MSM:>=50": [
				1428,
				1426,
				1337,
				1306,
				1252,
				1113
			],
			"Non-MSM:<30": [
				17,
				16,
				15,
				15,
				11,
				6
			],
			"Non-MSM:30-39": [
				103,
				101,
				96,
				92,
				79,
				48
			],
			"Non-MSM:40-49": [
				209,
				208,
				201,
				194,
				168,
				115
			],
			"Non-MSM:>=50": [
				688,
				682,
				680,
				654,
				614,
				477
			],
			"Unknown:<30": [
				77,
				31,
				27,
				27,
				26,
				21
			],
			"Unknown:30-39": [
				149,
				138,
				122,
				119,
				105,
				83
			],
			"Unknown:40-49": [
				246,
				235,
				196,
				191,
				178,
				147
			],
			"Unknown:>=50": [
				853,
				819,
				621,
				603,
				587,
				508
			]
		}
	},
	"callback": "C:\\Git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_5_5.json
// module id = 306
// module chunks = 0